module.exports = __webpack_public_path__ + "static/media/kalbitor.e0105cef.PNG";